import BaseAttribute from './baseAttribute';
import { TalentField, Category } from '../character/allValues';
import ValueAttribute from './valueAttribute';

export default class Talent extends ValueAttribute {
  public category: Category = Category.Talent;
  public talentField: TalentField;
  public isAvatarsTalent: boolean;

  public constructor(name: string, field: TalentField) {
    super(name);
    this.isAvatarsTalent = false;
    this.talentField = field;
  }

  public getClone() {
    const clone = new Talent(this.name, this.talentField);
    clone.isAvatarsTalent = this.isAvatarsTalent;
    clone.value = this.value;
  }
}
